import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Observable, firstValueFrom } from 'rxjs';
import { Project } from '../interfaces/project';
import { PortfolioProjectService } from '../portfolio-project.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '../shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-admin-project-list',
    imports: [CommonModule, RouterLink, MatButtonModule],
    templateUrl: './admin-project-list.component.html',
    styleUrl: './admin-project-list.component.sass'
})
export class AdminProjectListComponent implements OnInit {
  private readonly projectService = inject(PortfolioProjectService);
  private readonly router = inject(Router);
  private readonly dialog = inject(MatDialog);

  projects$: Observable<Project[]> = this.projectService.getProjects();

  ngOnInit(): void {
    void this.projectService.backfillMissingVisibility();
  }

  async confirmDeleteProject(project: Project): Promise<void> {
    const data: ConfirmDialogData = {
      title: 'Delete project?',
      message: `Are you sure you want to delete "${project.name}"? This cannot be undone.`,
      confirmLabel: 'Delete',
      cancelLabel: 'Cancel'
    };
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data,
      width: 'min(100%, 22rem)'
    });
    const confirmed = await firstValueFrom(ref.afterClosed());
    if (confirmed === true) {
      await this.projectService.deleteProject(project.id);
    }
  }

  editProject(id: string): void {
    this.router.navigate(['/admin/projects', id, 'edit']);
  }
}
